<template>
  <gh-table-page :show-tabs="false" ref="table" :before-save="beforeSave" module="plat.db" cls="ColumnService"
    :args-query="args" sort-by="Seq">
    <template #area_query>
      <v-layout row wrap align-center>
        <gh-invoke :is-intial="false" ref="invTable" module="plat.db" cls="DataTablesService" method="get">
          <template v-slot="{args,data,loading}">
            <template v-if="data && data instanceof Object ">
              <v-subheader>
                {{data.Db}}——{{data.Cd}}——{{data.Name}}
              </v-subheader>
            </template>
          </template>
        </gh-invoke>
      </v-layout>
    </template>
    <template #area_operation_before>
      <gh-menu :nudge-width="200" title="参照其它表创建" btn-text="参照其它表创建" :allow-submit="selectedTables.length>0"
        @submit="createColumns()">
        <v-layout column ma-3>
          <v-text-field v-model="queryTableArgs.keyword" label="关键字" @change="fetchTables()" clearable></v-text-field>
          <v-data-table v-model="selectedTables" :headers="headers" :items="TableResult[1]" class="elevation-1"
            :total-items="TableResult[0]" :pagination.sync="queryTableArgs.pagination" item-key="Id"
            :loading="queryTableArgs.isBusy" clearable>
            <template #items="props">
              <tr :active="props.selected" @click="selectTable(props)">
                <td>
                  <v-checkbox v-model="props.selected" primary hide-details readonly></v-checkbox>
                </td>
                <td>{{ props.item.Db }}</td>
                <td>{{ props.item.Cd }}</td>
                <td>{{ props.item.Name }}</td>
                <td>{{ props.item.Demo }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-layout>
      </gh-menu>
    </template>
    <template #area_edit="{model,props}">
      <v-container grid-list-md fluid>
        <v-layout column>
          <basic-property :model="model" :props="props"></basic-property>
          <dynamic-property :model="model" :props="props">
          </dynamic-property>
        </v-layout>
      </v-container>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import TableColumn from "./tableColumn.ts";
  export default TableColumn;
</script>